/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ImageContentComponent } from './image-content/image-content.component';
import { saveAs } from 'file-saver/dist/FileSaver';
import { Subject } from 'rxjs';
import { ReportProvider } from 'src/app/providers';
import { Report } from 'src/app/model';
// import { ApplicationProvider } from 'src/app/providers/application.provider';
// import { Application } from 'src/app/model/application';

@Component({
  selector: 'custom-download-preview',
  templateUrl: 'custom-preview.component.html',
  styleUrls: ['custom-preview.component.scss']
})
export class CustomPreviewComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  @Input() report: Report;
  @Input() showHover = true;
  @Input() showRight = false;
  @Input() disabled = false;
  @Input() previewOnly = false;
  @Input() full = false;

  public tooltip: ComponentRef<any>;
  public visible: boolean;

  editModal: BsModalRef;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private reportProvider: ReportProvider
  ) {}

  // @HostListener('focusin')
  /* @HostListener('mousehover') */
  showInfo(): void {
    if (this.visible || this.disabled) {
      return;
    }

    this.visible = true;
    const factory = this.resolver.resolveComponentFactory(ImageContentComponent);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
    this.tooltip.instance.report = this.report;
    this.tooltip.instance.showRight = this.showRight;
    const ackSubject = new Subject<boolean>();
    this.tooltip.instance.subject = ackSubject;

    ackSubject.subscribe(value => {
      if (value) {
        this.visible = false;
        if (this.tooltip) {
          this.tooltip.destroy();
        }
      }
    });
  }

  // @HostListener('focusout')
  @HostListener('mouseleave')
  hideInfo(): void {
    if (!this.visible) {
      return;
    }

    if(!(!this.tooltip.instance.loadingDup && !this.tooltip.instance.loading && this.tooltip.instance.isPdfFile() === true && this.tooltip.instance.hasPreview() === true)){
      this.visible = false;
      if (this.tooltip) {
        this.tooltip.destroy();
      }
    }
  }

  /**
   * Download document.
   */
  downloadDocument(): void {
    // this.document.disabled = true;
    // this.applicationProvider.downloadDocument(this.application.ID, this.document.ID)
    //   .subscribe(resp => {
    //     this.document.disabled = false;
    //     this.saveToFileSystem(resp, this.document.FILE_NAME);
    //   }, error => {
    //     this.document.disabled = false;
    //   
    //   });
  }

  private saveToFileSystem(response, fileName: string): void {
    const blob = new Blob([response], {});
    saveAs(blob, fileName);
  }
}


